import type { FetchTrackedOneGraphOperation } from "../../apollo/ApolloNativeModule";

import TypedNativeModules from "../internal/TypedNativeModules";

const fetchNativeOneGraphOperation: FetchTrackedOneGraphOperation = async (
  queryString: string,
  variablesJSONString: string,
  operationName: string | null,
  headers?: string,
  options?: string,
) => {
  const trackedFetch = TypedNativeModules.RNCoreNativeModule?.fetchTrackedOneGraphOperation;
  if (typeof trackedFetch === "function") {
    return await trackedFetch(queryString, variablesJSONString, operationName, headers, options);
  }

  const coreFetch = TypedNativeModules.RNCoreNativeModule?.fetchNativeOneGraphOperation;
  if (typeof coreFetch === "function") {
    return await coreFetch(queryString, variablesJSONString, operationName, options);
  }

  return {};
};

export default fetchNativeOneGraphOperation;
